import { cartoBasemapProvider } from './carto'
import { openFreeMapProvider } from './openfreemap'
import type { BasemapProvider } from './types'

/**
 * The basemap provider used by every GeoBorder map.
 *
 * Street tiles come from OpenFreeMap; satellite is Esri World Imagery. Both are
 * keyless.
 *
 * CARTO is kept wired up but unused. There is deliberately NO runtime failover:
 * switching providers is a one-line environment change plus a deploy, not
 * something the app decides on its own mid-session. Automatic failover was
 * built here and removed — it added an error listener, a subscription and a
 * live restyle path to every map for a switch that realistically happens once,
 * under supervision, if a provider's terms change again.
 *
 * To switch, set VITE_BASEMAP_PROVIDER=carto and redeploy. Vite inlines the
 * value at build time, so the change takes effect on the next build. The CARTO
 * key travels automatically via `transformCartoRequest` when one is configured.
 */
const provider = (import.meta.env.VITE_BASEMAP_PROVIDER ?? '').trim().toLowerCase()

export const activeBasemapProvider: BasemapProvider =
  provider === 'carto' ? cartoBasemapProvider : openFreeMapProvider

export { cartoBasemapProvider, transformCartoRequest } from './carto'
export { openFreeMapProvider } from './openfreemap'
export type { BasemapProvider, BasemapStyle, BasemapKind, BasemapStyleRequest } from './types'
